import Stack from '@mui/material/Stack'
import Typography from '@components/_mui/Typography'

const styles = {
  answer: (flagged, highlight) => ({
    p: 1,
    backgroundColor: flagged ? 'error.lighter' : highlight ? 'warning.lighter' : 'inherit',
    borderBottom: '1px solid',
    borderColor: 'divider',
  }),
}

export default function AssessmentAnswers({ data, ...rest }) {
  return (
    <Stack spacing={1} {...rest}>
      {data.map((answer) => (
        <AssessmentAnswerMap key={answer.index} answer={answer} />
      ))}
    </Stack>
  )
}

function AssessmentAnswerMap({ answer }) {
  if (answer.sub_question?.length) {
    const subQuestions = typeof answer.sub_question == 'string' ? answer.sub_question : answer.sub_question.join(', ')

    return (
      <Stack spacing={0.5} sx={styles.answer(answer.flagged, answer.highlight)}>
        <AssessmentAnswer answer={answer} />
        <Typography sx={{ color: answer.flagged || answer.highlight ? 'text.primary' : 'text.secondary' }}>{subQuestions}</Typography>
      </Stack>
    )
  }

  return <AssessmentAnswer answer={answer} sx={styles.answer(answer.flagged, answer.highlight)} />
}

function AssessmentAnswer({ answer, sx }) {
  const color = answer.flagged || answer.highlight ? 'text.primary' : 'text.secondary'
  const isArray = Array.isArray(answer.value)

  return (
    <Stack direction="row" spacing={2} sx={[{ justifyContent: 'space-between' }, ...(Array.isArray(sx) ? sx : [sx])]}>
      <Typography sx={{ color }}>{answer.text}</Typography>
      <Typography sx={{ color, fontWeight: 'bold' }} align="right">
        {isArray
          ? answer.value.map((value, index) => (
              <span key={`${value}-${index}`}>
                {index > 0 && <br />}
                {value}
              </span>
            ))
          : answer.value}
      </Typography>
    </Stack>
  )
}
